var _circle, _circle2, _rect, _path, _path2, _path3, _path4, _g, _g2, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31.5,
    fill: "white",
    stroke: "#47bba9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 28,
    fill: "rgba(71, 187, 169, 0.3)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#47bba9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.5003 49.3867V51.2934L50.8269 51.0601C50.4869 50.9401 50.2803 50.8267 50.2803 50.2467C50.2803 49.7734 50.6336 49.3867 51.0669 49.3867H51.5003Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.72 53.7537C53.72 54.227 53.3667 54.6137 52.9333 54.6137H52.5V52.707L53.1733 52.9404C53.5133 53.0604 53.72 53.1737 53.72 53.7537Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.793 45.333H49.2063C46.7797 45.333 45.333 46.7797 45.333 49.2063V54.793C45.333 57.2197 46.7797 58.6663 49.2063 58.6663H54.793C57.2197 58.6663 58.6663 57.2197 58.6663 54.793V49.2063C58.6663 46.7797 57.2197 45.333 54.793 45.333ZM53.5063 51.9997C54.0263 52.1797 54.7197 52.5597 54.7197 53.753C54.7197 54.7797 53.9197 55.613 52.933 55.613H52.4997V55.9997C52.4997 56.273 52.273 56.4997 51.9997 56.4997C51.7263 56.4997 51.4997 56.273 51.4997 55.9997V55.613H51.2597C50.1663 55.613 49.2797 54.6863 49.2797 53.553C49.2797 53.2797 49.4997 53.053 49.7797 53.053C50.053 53.053 50.2797 53.2797 50.2797 53.553C50.2797 54.1397 50.7197 54.613 51.2597 54.613H51.4997V52.353L50.493 51.9997C49.973 51.8197 49.2797 51.4397 49.2797 50.2463C49.2797 49.2197 50.0797 48.3863 51.0663 48.3863H51.4997V47.9997C51.4997 47.7263 51.7263 47.4997 51.9997 47.4997C52.273 47.4997 52.4997 47.7263 52.4997 47.9997V48.3863H52.7397C53.833 48.3863 54.7197 49.313 54.7197 50.4463C54.7197 50.7197 54.4997 50.9463 54.2197 50.9463C53.9463 50.9463 53.7197 50.7197 53.7197 50.4463C53.7197 49.8597 53.2797 49.3863 52.7397 49.3863H52.4997V51.6463L53.5063 51.9997Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0003 44L45.3337 34.6667H40.0137L40.0003 20H24.0003V34.6667H18.667L32.0003 44Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_90_14364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 34.667L36 26.667",
    stroke: "#05569F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_90_14364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6667 28.0003C29.0349 28.0003 29.3333 27.7018 29.3333 27.3337C29.3333 26.9655 29.0349 26.667 28.6667 26.667C28.2985 26.667 28 26.9655 28 27.3337C28 27.7018 28.2985 28.0003 28.6667 28.0003Z",
    fill: "#05569F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6667 28.0003C29.0349 28.0003 29.3333 27.7018 29.3333 27.3337C29.3333 26.9655 29.0349 26.667 28.6667 26.667C28.2985 26.667 28 26.9655 28 27.3337C28 27.7018 28.2985 28.0003 28.6667 28.0003Z",
    stroke: "#05569F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3337 34.6663C35.7018 34.6663 36.0003 34.3679 36.0003 33.9997C36.0003 33.6315 35.7018 33.333 35.3337 33.333C34.9655 33.333 34.667 33.6315 34.667 33.9997C34.667 34.3679 34.9655 34.6663 35.3337 34.6663Z",
    fill: "#47bba9",
    stroke: "#47bba9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_90_14364",
    x: 25,
    y: 23.667,
    width: 18,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.439216 0 0 0 0 0.396078 0 0 0 0 0.941176 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_90_14364"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_90_14364",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_90_14364",
    x: 25,
    y: 23.667,
    width: 11.333,
    height: 11.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.439216 0 0 0 0 0.396078 0 0 0 0 0.941176 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_90_14364"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_90_14364",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentation);
export default __webpack_public_path__ + "static/media/documentation.ff13ed969f1e2787f80e31f86ed46d3f.svg";
export { ForwardRef as ReactComponent };